<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Insurance Plan</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ company.name }}</div>
                    <div><span class="text-muted">Insurance Plan: </span>{{ insurancePlan.plan_name }}</div>
                </div>
            </div>

            <flat-pricing-form
                v-if="insurancePlan.billing_type == 'flat'"
                ref="flatPricingForm"
                :initial-value="formData"
            />

            <age-band-pricing-form
                v-if="insurancePlan.billing_type == 'age-band'"
                ref="ageBandPricingForm"
                :initial-value="formData"
                :employee-cost-covered="insurancePlan.employee_cost_covered"
            />

        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import FlatPricingForm from './FlatPricingForm'
import AgeBandPricingForm from './AgeBandPricingForm'

export default {
    props: ['client', 'insurancePlan', ],
    mixins: [FormMixin, ModalMixin],
    components: {FlatPricingForm, AgeBandPricingForm, },
    emits: ['updated', 'close', ],
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.insurancePlan.company_id)
        },
    },
    methods: {
        makeFormData() {
            if (this.insurancePlan.billing_type == 'flat') {
                return {
                    single_total_cost: this.insurancePlan.single_total_cost,
                    single_plus_one_total_cost: this.insurancePlan.single_plus_one_total_cost,
                    single_plus_children_total_cost: this.insurancePlan.single_plus_children_total_cost,
                    family_total_cost: this.insurancePlan.family_total_cost,
                    has_single_plus_one: this.insurancePlan.has_single_plus_one,
                    has_single_plus_children: this.insurancePlan.has_single_plus_children,
                    has_family: this.insurancePlan.has_family,
                }
            }
            else if (this.insurancePlan.billing_type == 'age-band') {
                const result = {}

                this.insurancePlan.insurance_plan_age_bands.forEach(ab => {
                    result[ab.age] = ab.total_cost
                })

                return result
            }
        },
        onSubmit() {
            let data = null
            let url = null
            if (this.insurancePlan.billing_type == 'flat') {
                if (!this.$refs.flatPricingForm.validate()) {
                    this.formErrors = this.$refs.flatPricingForm.formErrors
                    return
                }

                data = this.$refs.flatPricingForm.getFormData()
                url = `/clients/${this.client.id}/settings/insurance-plans/${this.insurancePlan.id}/flat-pricing`
            }
            else if (this.insurancePlan.billing_type == 'age-band') {
                if (!this.$refs.ageBandPricingForm.validate()) {
                    this.formErrors = this.$refs.ageBandPricingForm.formErrors
                    return
                }

                data = this.$refs.ageBandPricingForm.getFormData()
                url = `/clients/${this.client.id}/settings/insurance-plans/${this.insurancePlan.id}/age-band-pricing`
            }

            this.$store.dispatch('START_LOADING')
            this.$api.put(url, data).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved insurance pricing.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        }
    }
}
</script>
